import _ from 'lodash'
import { statuses, StatusColor, StatusKey } from '@core/theme/statuses'
import { MediaGeoJSON } from '@core/entities/template/TemplateQuestion/types'

export type ObservationStatus =
  | 'PROCESSING'
  | 'SUBMITTED'
  | 'ASSIGNED'
  | 'CLOSED'
  | 'REJECTED'

export const OBSERVATION_STATUSES_ALL: ObservationStatus[] = [
  'PROCESSING',
  'SUBMITTED',
  'ASSIGNED',
  'CLOSED',
  'REJECTED',
]

const observationStatusKeys: Record<ObservationStatus, StatusKey> = {
  PROCESSING: 'processing',
  SUBMITTED: 'submitted',
  ASSIGNED: 'assigned',
  REJECTED: 'rejected',
  CLOSED: 'closed',
}

export const ObservationStatusHelpers = {
  getLabel: (status: ObservationStatus) => {
    return (
      statuses[observationStatusKeys[status]]?.label ?? _.capitalize(status)
    )
  },

  getChipColor: (status: ObservationStatus): StatusColor => {
    return (
      statuses[observationStatusKeys[status]]?.color ?? statuses.closed.color
    )
  },
}

export type ObservationPermittedAction =
  | 'READ'
  | 'UPDATE'
  | 'CREATE_TASK'
  | 'UPLOAD_MEDIA'
  | 'CLOSE'
  | 'REJECT'

export type ObservationMedia = {
  id: string
  mimeType: string
  url: string
  expiryInMinutes: number
}

export type ObservationMediaResults = {
  originalMedia?: ObservationMedia
  amendedMedia?: ObservationMedia // low fps video used for frames analysis
  description?: string
  fps?: number
  items?: ObservationMediaResultItem[]
}

export type ObservationMediaResultItem = {
  media: {
    id: string
    mimeType: string
    url: string
    expiryInMinutes: number
    geoJson?: MediaGeoJSON
  }
  description?: string
}

export type ObservationCoordinatesInputType =
  | 'WHAT_3_WORDS'
  | 'DRAW_ON_MAP'
  | 'COORDINATES'
  | 'DEVICE_LOCATION'
  | 'UNKNOWN'

export type ObservationCoordinates = {
  latitude: number
  longitude: number
  accuracy?: number
  w3wLocation?: string
  inputType?: ObservationCoordinatesInputType
}

export type ObservationStatusCounts = Record<ObservationStatus, number>

export type ObservationListStats = {
  countByStatus: ObservationStatusCounts
}

export type ObservationCaptureMode = 'VIDEO' | 'AUDIO' | 'PHOTO'

export const OBSERVATION_CAPTURE_MODES_ALL: ObservationCaptureMode[] = [
  'VIDEO',
  'AUDIO',
  'PHOTO',
]
